import {useContext} from "react";
import OrganizationContext from "../context/OrganizationContext"

const useMasterAccount = () => {
    const {organization: masterAccountId} = useContext(OrganizationContext)
    return masterAccountId
}

export default useMasterAccount